import { render, staticRenderFns } from "./CadaItemView.vue?vue&type=template&id=454f9681&scoped=true&"
import script from "./CadaItemView.vue?vue&type=script&lang=js&"
export * from "./CadaItemView.vue?vue&type=script&lang=js&"
import style0 from "./CadaItemView.vue?vue&type=style&index=0&id=454f9681&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454f9681",
  null
  
)

export default component.exports